import Keycloak from "keycloak-js";
const KeycloakJSON = require("./_KeycloakJSON");

const keycloak = new Keycloak(KeycloakJSON)
export default keycloak;